import { render, staticRenderFns } from "./meetingHead.vue?vue&type=template&id=58d6bf8d&scoped=true&"
import script from "./meetingHead.vue?vue&type=script&lang=js&"
export * from "./meetingHead.vue?vue&type=script&lang=js&"
import style0 from "./meetingHead.vue?vue&type=style&index=0&id=58d6bf8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6bf8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d6bf8d')) {
      api.createRecord('58d6bf8d', component.options)
    } else {
      api.reload('58d6bf8d', component.options)
    }
    module.hot.accept("./meetingHead.vue?vue&type=template&id=58d6bf8d&scoped=true&", function () {
      api.rerender('58d6bf8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/meetingHead.vue"
export default component.exports